/**
 * Build a URL path for the journey in-progress page with optional search params.
 */
export function inProgressUrl(params: {
    journeyType?: string;
    journeyInstanceId?: number;
    journeyInstanceUlid?: string;
}): string {
    const url = new URL(
        "/journeys/instances/in-progress",
        window.location.origin,
    );
    if (params.journeyType) {
        url.searchParams.set("journeyType", params.journeyType);
    }
    if (params.journeyInstanceId != null) {
        url.searchParams.set(
            "journeyInstanceId",
            String(params.journeyInstanceId),
        );
    }
    if (params.journeyInstanceUlid) {
        url.searchParams.set("journeyInstanceUlid", params.journeyInstanceUlid);
    }
    return url.pathname + url.search;
}
